import React from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";

const StyledInput = styled.input`
  border: none;
  border-bottom: 0.8px solid #797a80;
  outline: none;
  padding: 7px 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #37373a;
  &:focus::placeholder {
    color: transparent;
  }
`;

const MainInput = ({ placeholder, ...props }) => {
  const { t } = useTranslation();
  return <StyledInput {...props} placeholder={t(placeholder)} />;
};

export default MainInput;
